import { FC } from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'

interface IFSubmitButtonProps {
  onClick: () => void
  disabled?: boolean
  className?: string
}

const SubmitButton: FC<IFSubmitButtonProps> = ({
  onClick,
  disabled = false,
  className,
}) => {
  return (
    <StyledWrapper className={className} onClick={onClick} disabled={disabled}>
      선택 완료
    </StyledWrapper>
  )
}

export default SubmitButton

const StyledWrapper = styled(Button)`
  width: 100%;
  padding: 13px;
  font-size: 16px;
`
